<template>
  <div class="page flex-col" :style="{ backgroundImage: `url(${meta.bg})` }">
    <top-bar />
    <logo />

    <div id="loginInfo">
      <div id="header">
        <div class="label-text">
          <img src="./images/pet.png" alt="">
          {{ $t('person_center["Pet Profile"]') }}
        </div>
      </div>

      <div class="input-container" @click.stop="handleUpload">
        <div v-if="form.petImage" :style="{ backgroundImage: `url(${form.petImage})` }" class="pet-avatar"></div>
        <img v-else src="./images/pet.png" alt="" class="pet-avatar">
        <div class="right_item offset-top">
          <span ref="petAvatar">
            <span class="font-red">*</span>
            {{ $t('edit_info["Click to choose profile picture"]') }}
            <br>{{ $t('edit_info[\'Required\']') }}
          </span>
          <el-upload
            class="no-space"
            action="#"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload">
            <span class="upload-profile-image"></span>
          </el-upload>
        </div>
      </div>

      <div class="input-container">
        <div class="flex-fixed">
          <img-modal>
            <img src="./images/idca.png" alt="" class="icon">
            <span class="label-text">{{ $t('reg["Dog Tag ID"]') }}</span>
            <i class="el-icon-question"></i>
          </img-modal>
        </div>
        <div class="right_item">
          <input type="text" maxlength="15"
                 :disabled="!!this.$route.query.generatedId"
                 ref="dogTagId" v-model="form.generatedId"
                 :placeholder="$t('edit_info[\'Required\']')">
        </div>
      </div>

      <div class="input-container">
        <div>
          <img src="./images/pet2.png" alt="" class="icon">
          <span class="label-text">{{ $t('edit_info["Nickname"]') }}</span>
        </div>
        <div class="right_item">
          <input type="text" maxlength="16" v-model="form.petNickname"
                 ref="petNickName" :placeholder="$t('edit_info[\'Required\']')">
        </div>
      </div>

      <div class="input-container">
        <div>
          <img src="./images/zhua.png" alt="" class="icon">
          <span class="label-text">{{ $t('edit_info["Breed"]') }}</span>
        </div>
        <div class="right_item">
          <input type="text" maxlength="16" v-model="form.petBreed" :placeholder="$t('edit_info[\'Optional\']')">
        </div>
      </div>

      <div class="input-container">
        <div>
          <img src="./images/bir.png" alt="" class="icon">
          <span class="label-text">{{ $t('edit_info["Birth"]') }}</span>
        </div>
        <div class="right_item" style="width: 60%;">
          <div class="date-picker" v-show="!showCalendar" @click="showCalendarMe">
            {{ date || $t('edit_info[\'Optional\']') }}
          </div>
          <van-calendar
            :confirm="false"
            v-model="showCalendar"
            @confirm="onConfirm"
            v-show="showCalendar"
            :min-date="minDate"
          />
        </div>
      </div>

      <div class="input-container">
        <div>
          <img src="./images/pet2.png" alt="" class="icon">
          <span class="label-text">{{ $t('edit_info["Size"]') }}</span>
        </div>
        <div class="right_item">
          <input type="text" maxlength="16" v-model="form.somatotype" :placeholder="$t('edit_info[\'Optional\']')">
        </div>
      </div>

      <div class="input-container special-need">
        <div class="label-text">
          <img src="./images/talk.png" alt="" class="icon">
          <span class="label-text">{{ $t('edit_info["Special Need"]') }}</span>
        </div>
        <div class="right_item ipt-special-need-wrap">
          <textarea type="text" class="ipt ipt-special-need" maxlength="64" v-model="form.specialNeeds" :placeholder="$t('edit_info[\'Optional\']')"></textarea>
        </div>
      </div>
      <img src="@/assets/title_pet.png" alt="" class="title-pet">
    </div>

    <div class="save-button-container">
      <div class="save-button" @click="save">
        {{ saveBtnLabel }} <i v-show="saving" class="el-icon-loading"></i>
      </div>
    </div>

    <custom-dialog
      v-model="showDialog"
      width="500"
      :confirmText="$t('base.ok')"
      cancelType="primary"
      :confirmBtnLoading="confirmBtnLoading"
      @confirm="confirmModel"
      @change="changeModel"
      :title="$t('base.notice')"
    >
      <div>
        {{ confirmInfo }}
      </div>
    </custom-dialog>
  </div>
</template>


<script>
import meta from "../../utils/meta"
import axios from "../../utils/request";
import CustomDialog from "../../components/alert.vue";
import VanCalendar from "vant/lib/calendar"
import ImgModal from "../../components/ImgModal.vue";

let saveFailMsgTimeout

/**
 * 截取图片
 * @param {HTMLImageElement} img - 图片元素
 * @param {number} x - 起始x坐标
 * @param {number} y - 起始y坐标
 * @param {number} width - 截取宽度
 * @param {number} height - 截取高度
 * @returns {Promise<Blob>} - 返回截取后的图片Blob
 */
async function cropImage(img, x, y, width, height) {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');

  // 绘制截取部分
  ctx.drawImage(img, x, y, width, height, 0, 0, width, height);

  // 转换为Blob
  return new Promise((resolve) => {
    canvas.toBlob(resolve, 'image/jpeg', 1); // 先用JPEG格式获取
  });
}

/**
 * 压缩图片
 * @param {Blob} blob - 图片Blob
 * @param {number} maxWidth - 最大宽度
 * @param {number} maxHeight - 最大高度
 * @param {number} quality - 质量 (0-1)
 * @returns {Promise<Blob>} - 返回压缩后的图片Blob
 */
async function compressImageToWebP(blob, maxWidth = 400, maxHeight = 400, quality = 0.8) {
  const img = await createImageFromBlob(blob);
  const canvas = document.createElement('canvas');

  // 计算缩放比例
  let width = img.width;
  let height = img.height;

  if (width > maxWidth) {
    height = Math.round((height * maxWidth) / width);
    width = maxWidth;
  }

  if (height > maxHeight) {
    width = Math.round((width * maxHeight) / height);
    height = maxHeight;
  }

  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, width, height);

  // 转换为Blob
  return new Promise((resolve) => {
    canvas.toBlob(resolve, 'image/webp', quality);
  });
}

// 辅助函数：从Blob创建Image对象
function createImageFromBlob(blob) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = URL.createObjectURL(blob);
  });
}


export default {
  name: 'edit_info',
  components: {ImgModal, CustomDialog, VanCalendar},
  mounted() {
    if (this.$route.params.petId !== '0') {
      axios({
        method: "get",
        url: '/businese/dog_tag/' + this.$route.params.petId
      }).then(({ data }) => {
        this.form = data
        this.date = data.petBirthday
      })
    }
  },
  data() {
    return {
      confirmInfo: '',
      showDialog: false,
      showCalendar: false,
      minDate: new Date(2010, 0, 1),
      date: null,
      confirmBtnLoading: '',
      saveBtnLabel: this.$t('base.save'),
      saving: false,
      form: {
        petNickname: '',
        ownerNickname: '',
        contactNumber: '',
        petBreed: '',
        petBirthday: '',
        specialNeeds: '',
        generatedId: this.$route.query.generatedId || '',
        somatotype: '',
        petImage: ''
      },
      meta
    }
  },
  methods: {
    changeModel() {
      this.showDialog = false
    },
    confirmModel() {
      this.showDialog = false
    },
    click() {
      this.$router.push('/login')
    },
    goBack() {
      window.history.back();
    },
    onConfirm(date) {
      this.showCalendar = false;
      this.formatD(date)
    },
    formatD(date){
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      this.date = `${year.toString()}-${month}-${day}`;
    },
    showCalendarMe() {
      this.showCalendar = true
    },
    save() {
      if (!this.form.petNickname) {
        this.saveBtnLabel = this.$t('edit_info["Please enter nickname"]')
        this.$refs.petNickName.focus()
      }
      if (!this.form.generatedId) {
        this.saveBtnLabel = this.$t('edit_info["Please enter Dog Tag ID"]')
        this.$refs.dogTagId.focus()
      }
      if (!this.form.petImage) {
        this.saveBtnLabel = this.$t('edit_info["Please upload image"]')
        this.$refs.petAvatar.classList.add('error')
      }

      clearTimeout(saveFailMsgTimeout)
      if (!this.form.petNickname || !this.form.generatedId || !this.form.petImage) {
        saveFailMsgTimeout = setTimeout(() => {
          this.saveBtnLabel = this.$t('base.save')
        }, 5000)
        return
      }

      this.saving = true
      this.saveBtnLabel = this.$t('base.saving')
      this.form.ownerNickname = this.meta.user.userName
      this.form.contactNumber = this.meta.user.phoneNumber
      this.form["petBirthday"] = this.date
      axios({
        // petId 为 ’0‘ 表示新增宠物，否则为修改宠物信息
        // 如果 petId 是 ’0‘ 就使用 post 方法，否则使用 put 方法
        method: this.$route.params.petId !== '0' ? "put" : "post",
        url: '/businese/dog_tag',
        data: this.form
      }).then(({ code, msg }) => {
          if (code !== 200) {
            this.showDialog = true
            this.confirmInfo = msg
          } else {
            this.$route.params.petId === '0'
              ? this.$router.replace('/person_list')
              : this.$router.back()
          }
        }
      ).finally(() => this.saving = false)
    },
    handleUpload() {
      this.$refs.petAvatar.classList.remove('error')
      document.getElementsByClassName('upload-profile-image')[0].click()
    },
    async beforeAvatarUpload(file) {
      const isIMAGE = file.type.includes('image');
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isIMAGE) {
        this.$message.error(this.$t('edit_info[\'Please upload image\']'));
        return false
      }
      if (!isLt10M) {
        this.$message.error(this.$t('edit_info[\'The image cannot large than 10MB\']'));
        return false;
      }

      // 1. 创建Image对象
      const img = await createImageFromBlob(file);

      // 2. 截取图片
      const [ x, y, w, h ] = img.width < img.height
        ? [ 0, (img.height - img.width) / 2, img.width, img.width ]
        : [ (img.width - img.height) / 2, 0, img.height, img.height ]
      const croppedBlob = await cropImage(img, x, y, w, h);

      // 3. 压缩图片 (最大宽度400px，最大高度400px)并转换为WebP格式
      const webpBlob = await compressImageToWebP(croppedBlob);

      // 将 Blob 转换为 File 对象，方便设置文件名
      const webpFile = new File([webpBlob],
        'converted-image.webp', {
        type: 'image/webp'
      });

      const timeout = setTimeout(() =>
        this.$message.info('Uploading ...'), 1000)
      const formData = new FormData()
      formData.append('file', webpFile)
      axios({
        method: 'post',
        url: '/common/upload',
        data: formData,
        timeout: 30000
      }).then(({code, url, msg}) => {
        if (code !== 200) {
          console.error(msg)
          this.$message.error(msg || this.$t('edit_info[\'Upload image error\']'))
          return
        }
        this.form.petImage = url
      }).finally(() => clearTimeout(timeout))
      return false
    }
  }
}
</script>

<style scoped>
.page {
  background-size: cover;
  position: relative;
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  padding: 3.73vw 3vw 6.4vw 3vw;
  background-position: center;
  text-align: center;
  background-attachment: fixed;
  z-index: 1;
  box-sizing: border-box;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

#loginInfo {
  background: linear-gradient(180deg, #FFFFFF 0%, #F7FEF1 100%);
  box-shadow: 0 7px 21px 0 rgba(5, 78, 171, 0.2);
  border-radius: 28px;
  margin-top: 15vw;

  position: relative;
}

/deep/ .el-checkbox__original {
  border-radius: 50%;
}

#header {
  height: 43px;
  font-weight: bold;
  font-size: 16px;
  color: #1B1B1B;
  line-height: 22px;
  text-align: center;
  font-style: normal;
  display: flex;
  justify-content: center;
  align-items: center;

  background: linear-gradient(180deg, #ECAF693B 0%, #E5E8993B 100%);
  border-radius: 28px 28px 0 0;
}

#header > .label-text {
  font-weight: bold;
}
.offset-top {
  margin-bottom: 1.2em;
}
.font-red {
  color: red;
  font-weight: bold;
  font-size: 1.5em;
  vertical-align: text-top;
}

.title-pet {
  width: 74px;
  height: 46px;
  position: absolute;
  top: -43px;
  left: 39px;
}

.label-text {
  height: 22px;
  font-size: 16px;
  color: #323233;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}

.input-container {
  display: flex;
  justify-content: space-between;
  margin: 0 11px;
  align-items: center;
  border-bottom: 1px solid #E6E6EB;
  padding-bottom: 15px;
  padding-top: 16px;
}
.input-container>:first-child:not(.special-need) {
  flex: 0 0 auto;
}
.input-container.special-need {
  border-bottom: none;
}
.error {
  color: red
}

.right_item {
  height: 22px;
  font-weight: 400;
  font-size: 16px;
  color: #8E8E94;
  flex: 0 1 auto;
  line-height: 22px;
  text-align: right;
  font-style: normal;
}
.right_item input {
  width: 100%;
}
.no-space {
  flex: 0 0 0;
}
input,textarea {
  border: none;
  background: transparent;
  text-align: right;
}
.special-need.input-container {
  align-items: stretch;
  flex-direction: column;
  gap: 5px;
}
.ipt-special-need-wrap,.ipt-special-need {
  height: 20vw;
  flex: 1;
  text-align: left;
}
.ipt-special-need {
  text-align: left;
  box-shadow: 0 1px 3px #0002;
  border: 1px solid #eee;
  border-radius: .5em;
  background: #fff;
  width: calc(100% - 16px);
  max-width: calc(100% - 16px);
  min-width: calc(100% - 16px);
  min-height: 20vw;
  padding: 5px 8px;
}
.pet-avatar {
  width: 59px;
  height: 59px;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
}

.save-button {
  flex: 1;
  line-height: 58px;
  color: white;
  height: 58px;
  background: linear-gradient(133deg, #F8B029 0%, #F6923D 100%);
  border-radius: 20px;
  cursor: pointer;
}

.save-button-container {
  display: flex;
  padding: 30px 28px 100px 28px;
}
</style>



// WEBPACK FOOTER //
// src/views/edit_info/index.vue